export default __webpack_public_path__ + "static/media/dots-img.ad73102d.svg";